module.exports = __webpack_public_path__ + "static/media/mongodb.8d95890a.png";